module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v1-620.50b3686f.png";